const changeFirstLetter = func => str => str && (func.call(str[0]) + str.slice(1));

export const firstLetterToLowerCase = changeFirstLetter(String.prototype.toLowerCase);

export const firstLetterToUpperCase = changeFirstLetter(String.prototype.toUpperCase);

export const arrayToCamelCase = arr => {
	return firstLetterToLowerCase(arr.map(firstLetterToUpperCase).join(''));
};

export const isFunction = value => typeof value === 'function';

export default {firstLetterToLowerCase, firstLetterToUpperCase, arrayToCamelCase, isFunction};
